import { Lemonade } from '@oneclick/react-lemonade-editor';
import clsx from 'clsx';
import LayoutHeader from 'core/layout/LayoutHeader';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import FooterAutoSaving from 'core/modules/compositions/FooterAutoSaving/FooterAutoSaving';
import { setStyle } from 'core/utils/lemonade';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderSave from 'core/modules/components/headers/HeaderSave';
import useDialogLemonadeEditor from './useDialogLemonadeEditor';

const DialogLemonadeEditor = ({
  selectedTemplate,
  onClose,
  t,
  open,
  onSubmit,
  course,
  item,
  uploadURL,
  newActivityContent,
  onClickFeedbackAi,
  hasRequiredTitle,
}) => {
  const { Editor, Question, data, onSaveDataLemonade, isPowerLessonMode, isUpdating, isTitleEmpty, background } = useDialogLemonadeEditor({
    selectedTemplate,
    onSubmit,
    course,
    open,
    item,
    uploadURL,
    newActivityContent,
    onClickFeedbackAi,
    hasRequiredTitle,
  });

  return (
    <Dialog ariaLabel={t('lemonade:Edit activity')} isOpen={open} onClose={onClose} isHeaderHidden className="dialog-lemonade-editor lemonade-view" size="all-screen">
      <LayoutHeader
        isMainLandmark={false}
        header={
          !isPowerLessonMode && (
            <HeaderSave
              onSuccess={() => onSaveDataLemonade(data)}
              onCancel={onClose}
              buttonTextSucess={t('actions:Save')}
              buttonTextCancel={t('actions:Cancel')}
              disabledSuccess={isUpdating || isTitleEmpty}
            />
          )
        }
        footer={
          isPowerLessonMode && <FooterAutoSaving onCancel={onClose} onSuccess={() => onSaveDataLemonade(data)} disableSuccess={isUpdating || isTitleEmpty} />
        }
      >
        <Lemonade className={clsx('lemon-test', 'lemonade-exercises__with-controls', { 'lemonade-exercises__with-title': hasRequiredTitle })}>
          <div className="lemonade-exercises__left">
            <Editor />
          </div>
          <div className="lemonade-view__container">
            <div style={setStyle(background)}>
              <div className="lemonade-view__containe-preview-header">{t('lemonade:Student preview')}</div>
              <Question />
            </div>
          </div>
        </Lemonade>
      </LayoutHeader>
    </Dialog>
  );
};

DialogLemonadeEditor.propTypes = {
  selectedTemplate: PropTypes.string,
  open: PropTypes.bool,
  course: PropTypes.object,
  item: PropTypes.object,
  uploadURL: PropTypes.string,
  newActivityContent: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  t: PropTypes.func,
  isPowerLessonMode: PropTypes.bool,
  onClickFeedbackAi: PropTypes.func,
  hasRequiredTitle: PropTypes.bool,
};

DialogLemonadeEditor.defaultProps = {
  selectedTemplate: null,
  open: false,
  course: {},
  item: {},
  uploadURL: '',
  newActivityContent: null,
  onClose: () => {},
  onSubmit: () => {},
  hasRequiredTitle: false,
};

export default DialogLemonadeEditor;
